export default "__VITE_ASSET__C_YfIwTr__"